import { render, staticRenderFns } from "./TileText.vue?vue&type=template&id=0b670cb6&scoped=true&"
import script from "./TileText.vue?vue&type=script&lang=js&"
export * from "./TileText.vue?vue&type=script&lang=js&"
import style0 from "./TileText.vue?vue&type=style&index=0&id=0b670cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b670cb6",
  null
  
)

export default component.exports